var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBathroom = function SvgBathroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460.8 486.4c-20.898 0-30.421-10.624-34.756-20.838C477.244 437.154 512 382.583 512 320c0-14.14-11.46-25.6-25.6-25.6H273.169c.043-1.553-.145-3.14-.708-4.693-2.415-6.647-9.762-10.069-16.41-7.646-5.299 1.929-8.397 6.997-8.26 12.339H66.398V76.8c0-28.237 22.963-51.2 51.2-51.2 12.211 0 23.219 4.523 31.966 11.708-23.202 16.196-33.818 46.379-23.697 74.197a25.59 25.59 0 0 0 32.81 15.301l72.166-26.266c13.286-4.838 20.139-19.524 15.3-32.811C236.979 42.53 212.813 25.6 186.01 25.6c-3.874 0-7.714.384-11.503 1.084C160.555 10.598 140.561 0 117.598 0c-42.351 0-76.8 34.449-76.8 76.8v217.6H25.6C11.46 294.4 0 305.86 0 320c0 62.515 34.688 117.026 85.794 145.459-4.36 10.266-13.73 20.941-34.594 20.941-7.074 0-12.8 5.726-12.8 12.8S44.126 512 51.2 512c32.896 0 49.775-17.621 57.711-36.053 17.946 6.647 37.257 10.453 57.489 10.453h179.2c20.215 0 39.518-3.806 57.463-10.436C411 494.387 427.913 512 460.8 512c7.074 0 12.8-5.726 12.8-12.8s-5.726-12.8-12.8-12.8M172.885 53.521a38.4 38.4 0 0 1 13.124-2.321c15.684 0 30.413 9.685 36.088 25.276l-72.166 26.266c-7.254-19.926 3.02-41.968 22.954-49.221M345.6 460.8H166.4c-77.764 0-140.8-63.044-140.8-140.8h460.8c0 77.756-63.036 140.8-140.8 140.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207.898,
    cy: 149.751,
    r: 12.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.408,
    cy: 197.888,
    r: 12.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.918,
    cy: 245.973,
    r: 12.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.985,
    cy: 136.619,
    r: 12.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.643,
    cy: 183.023,
    r: 12.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.258,
    cy: 229.427,
    r: 12.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.907,
    cy: 275.797,
    r: 12.8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.861,
    cy: 162.901,
    r: 12.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.071,
    cy: 212.343,
    r: 12.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.315,
    cy: 261.794,
    r: 12.8
  })));
};
export default SvgBathroom;